<header
  class="flex flex-row justify-between shadow-md p-4 items-center h-max-header"
  [ngClass]="{
    '!justify-center': isJump && isMobile,
    'bg-danger-200':
      (env == 'Development' || env == 'LocalHost') && !includesGrupo8(),
    'bg-gray-25':
      (env != 'Development' && env != 'LocalHost') || includesGrupo8(),
  }"
>
  <div class="flex flex-row gap-4 items-center">
    @if (currentRoute.length > 1 && !includes()) {
      <button (click)="goBack()">
        <span class="material-symbols-outlined text-primary-500">
          arrow_back
        </span>
      </button>
    } @else {
      @if (!includes()) {
        <button [matMenuTriggerFor]="menu">
          <span class="material-symbols-outlined text-primary-500"> menu </span>
        </button>
      }
    }
    <button (click)="goHome()">
      <span class="text-md-semibold text-primary-1000">{{
        includesProfile()
          ? "Perfil"
          : !includes()
            ? "Aéreos"
            : isJump
              ? ""
              : "Ingreso"
      }}</span>
    </button>
  </div>
  <div
    class="flex flex-row gap-10 items-center"
    [ngClass]="{
      'gap-10': !isJump,
      'gap-7': isJump,
    }"
  >
    @if (user) {
      @if (!isMobile || !user?.isOrganization) {
        <div class="flex flex-col gap-1 text-gray-700">
          <span class="text-sm-bold">{{
            user?.name + " " + user?.surname
          }}</span>
          <span class="text-xxs-medium">{{ user.email }}</span>
        </div>
      }
      @if (user?.isOrganization || (user?.agency?.isConsolidator && user?.agency?.isConsolidatorWithChildren)) {
        <div class="flex flex-col gap-1 text-gray-700">
          <span class="text-sm-bold">Agencia</span>
          <div class="flex flex-row gap-2 items-center">
            <span class="text-xxs-medium">{{ agencyName }}</span>
            @if (currentRoute == "") {
              @if (isSet) {
                <span
                  class="material-symbols-outlined cursor-pointer delete-agency"
                  #tooltip="matTooltip"
                  matTooltip="{{
                    user?.agency?.isConsolidator
                      ? 'Volver a reservas de consolidador'
                      : 'Volver a reservas de Carnival'
                  }}"
                  [matTooltipPosition]="'above'"
                  (click)="deleteAgency()"
                  >close</span
                >
              } @else {
                <span
                  class="material-symbols-outlined withFill edit cursor-pointer"
                  (click)="openModal()"
                  >edit</span
                >
              }
            }
          </div>
        </div>
      }
      @if (user && isChildAgency() && selectionRequired && hasConsolidator()) {
        <div class="flex flex-col gap-1 text-gray-700">
          <span class="text-sm-bold">Consolidador</span>
          <div class="flex flex-row gap-2 items-center">
            <span class="text-xxs-medium">{{ consolidatorName || '--' }}</span>
            @if (currentRoute == "" && canChangeConsolidator()) {
              <span
                class="material-symbols-outlined withFill edit cursor-pointer"
                #tooltip="matTooltip"
                matTooltip="Cambiar consolidador"
                [matTooltipPosition]="'above'"
                (click)="openConsolidatorModal()"
                >edit</span
              >
            }
          </div>
        </div>
      }
    }
    @if (currencyView.enabled()) {
      <div class="flex flex-col gap-1 text-gray-700">
        <span class="text-sm-bold">Moneda</span>
        <button
          class="flex flex-row gap-1 items-center cursor-pointer"
          [matMenuTriggerFor]="currencyMenu"
        >
          <span class="text-xxs-medium">{{
            currencyView.viewCurrency() === ""
              ? "Originales"
              : currencyView.preferredCurrency()
          }}</span>
          <span class="material-symbols-outlined text-primary-500 text-base"
            >expand_more</span
          >
        </button>
      </div>
    }
    @if (!isMobile || isJump) {
      <button (click)="goHome()">
        <img
          [src]="imageUrl"
          [ngClass]="{
            'h-[55px]': isJump,
            'h-[45px]': !isJump,
          }"
        />
      </button>
    }
  </div>
</header>
<ng-template #componenteContainer>
  <div class="flex flex-col justify-between gap-4 p-4 rounded-2xl min-h-80">
    <div class="flex flex-col justify-start w-full gap-4">
      <span class="icon"> </span>
      <h2 class="text-lg-bold text-primary-900">Elegir agencia</h2>
    </div>

    <div>
      <cv-autocomplete
        [label]="'Nombre de la agencia'"
        [placeholder]="'Escribir nombre a buscar'"
        [options]="options"
        [loading]="loading"
        [myControl]="agency"
        (optionSelected)="onOptionSelected()"
      />
    </div>

    <div
      class="flex items-center gap-2.5 w-full"
      [ngClass]="{ 'flex-row': !isMobile, 'flex-col-reverse': isMobile }"
    >
      <div class="w-full">
        <ngx-button
          [size]="'lg'"
          [type]="'secondary'"
          class="w-full"
          (click)="close()"
        >
          Cancelar
        </ngx-button>
      </div>
      <div class="w-full">
        <ngx-button
          [size]="'lg'"
          [type]="'primary'"
          class="w-full"
          (click)="apply()"
          [disabled]="buttonDisabled || agency.value.length < 3"
        >
          Aplicar
        </ngx-button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #consolidatorModalTemplate>
  <div class="flex flex-col justify-between gap-4 p-4 rounded-2xl min-h-80">
    <!-- Header -->
    <div class="flex flex-col justify-start w-full gap-4">
      <div class="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
        <span class="material-symbols-outlined text-primary-500 text-xl">arrow_selector_tool</span>
      </div>
      <h2 class="text-lg-bold text-primary-800">Elegir consolidador</h2>
    </div>

    <!-- Loading state -->
    @if (consolidatorLoading) {
      <div class="flex justify-center items-center py-8">
        <span>Cargando consolidadores...</span>
      </div>
    }

    <!-- Radio buttons -->
    @if (!consolidatorLoading && consolidatorOptions.length > 0) {
      <mat-radio-group
        class="flex flex-col gap-3"
        [(ngModel)]="selectedConsolidatorIndex"
        [color]="'primary'"
        (change)="onConsolidatorSelected()"
      >
        @for(option of consolidatorOptions; track $index) {
          <mat-radio-button [value]="$index" class="text-md text-gray-700">
            {{ option.name }}
          </mat-radio-button>
        }
      </mat-radio-group>
    }

    <!-- No consolidators message -->
    @if (!consolidatorLoading && consolidatorOptions.length === 0) {
      <div class="text-center py-8 text-gray-500">
        <p>No hay consolidadores disponibles</p>
      </div>
    }

    <!-- Buttons -->
    <div
      class="flex items-center gap-2.5 w-full"
      [ngClass]="{ 'flex-row': !isMobile, 'flex-col-reverse': isMobile }"
    >
      <div class="w-full">
        <ngx-button
          [size]="'lg'"
          [type]="'secondary'"
          class="w-full"
          (click)="closeConsolidatorModal()"
        >
          Cancelar
        </ngx-button>
      </div>
      <div class="w-full">
        <ngx-button
          [size]="'lg'"
          [type]="'primary'"
          class="w-full"
          (click)="applyConsolidator()"
          [disabled]="consolidatorButtonDisabled || consolidatorOptions.length === 0"
        >
          Aplicar
        </ngx-button>
      </div>
    </div>
  </div>
</ng-template>
<mat-menu #menu (closed)="isMenu = !isMenu" class="menu">
  @if (user?.agency?.isChild || isWhiteLabel) {
    <menu
      mat-menu-items
      class="py-[6px] cursor-pointer hover:bg-background-50"
      (click)="redirect()"
    >
      <div class="pl-4 text-xs-medium text-black">Perfil</div>
    </menu>
  }
  <menu
    mat-menu-items
    class="py-[6px] cursor-pointer hover:bg-background-50"
    (click)="logout()"
  >
    <div class="pl-4 text-xs-medium text-black">Salir</div>
  </menu>
</mat-menu>
<mat-menu #currencyMenu="matMenu" class="menu">
  <menu
    mat-menu-items
    class="py-[6px] cursor-pointer hover:bg-background-50"
    [ngClass]="{ 'bg-background-50': currencyView.viewCurrency() === '' }"
    (click)="selectViewCurrency('')"
  >
    <div class="pl-4 text-xs-medium text-black">Valores originales</div>
  </menu>
  <menu
    mat-menu-items
    class="py-[6px] cursor-pointer hover:bg-background-50"
    [ngClass]="{
      'bg-background-50':
        currencyView.viewCurrency() === currencyView.preferredCurrency(),
    }"
    (click)="selectViewCurrency(currencyView.preferredCurrency())"
  >
    <div class="pl-4 text-xs-medium text-black">
      {{ currencyView.preferredCurrency() }}
    </div>
  </menu>
</mat-menu>
